import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useVariantsStore } from '../../../store/variants';
import { isSellable } from '../utils';
export default function ProductStock({ defaultValue, ...product }) {
    const selectedVariant = useVariantsStore((state) => state.selectedVariant);
    const availability = selectedVariant?.availability ?? product.availability;
    const color = isSellable(selectedVariant ? selectedVariant : product, 1) ? 'text-green' : 'text-danger';
    return (_jsx("div", { className: "d-flex align-items-center product__detail-availability", children: _jsx(_Fragment, { children: _jsx("span", { className: ` ${color} small font-weight-bold`, children: availability.name }) }) }));
}
